import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("stratedge-admin-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const adminFileUrl = (path) => `${API}/files/${path}?auth=${localStorage.getItem("stratedge-admin-token")}`;

export const expertApi = axios.create({ baseURL: API });
expertApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("stratedge-expert-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const clientApi = axios.create({ baseURL: API });
clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("stratedge-client-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrlFor = (path, kind = "admin") =>
  `${API}/files/${path}?auth=${localStorage.getItem(`stratedge-${kind}-token`)}`;
